<template>
  <div class="MoreInfoForm">
    <h2 class="gl_form-title">
      {{ t('rater.common.more-info.form-legend') }}
    </h2>

    <CardInfoComponent
      v-if="props.configurations.tags.moreInfoAlert"
      :icon="props.configurations.tags.moreInfoAlert.icon"
    >
      {{ props.configurations.tags.moreInfoAlert.label }}
    </CardInfoComponent>

    <InsuredInfoComponent
      :key="configurations"
      ref="$insuredInfoComponent"
      :answers="answers"
      :showTitle="true"
      :relationships="configurations.relationships"
      :onlyHolderPostalCode="onlyHolderPostalCode"
      :cp-validation-rules="postalCodeRules"
      :useTooOldGreaterOrEqual="extra?.useTooOldGreaterOrEqual"
      :configurations="configurations"
    />
  </div>
</template>

<script lang="ts" setup>
  import CardInfoComponent from '@/modules/common/common/components/panels/CardInfoComponent.vue'
  import InsuredInfoComponent from '@/modules/common/common/components/panels/InsuredInfoComponent.vue'
  import { useRules } from '@/modules/core/composables/useRulesComposable'
  import BranchEnum from '@/modules/core/models/BranchEnum'
  import type DentalRaterAnswers from '@/modules/dental/rater/models/APP/DentalRaterAnswers'
  import { computed, onBeforeMount, ref } from 'vue'
  import { useI18n } from 'vue-i18n'

  defineExpose({ triggerSubmit })

  const { t } = useI18n()
  const { isNotFromNavarra } = useRules()

  interface PropsInterface {
    nextForm: String[]
    answers: DentalRaterAnswers
    configurations: any
    store: any
    extra?: Record<string, any> | null
  }
  const props = withDefaults(defineProps<PropsInterface>(), {})

  const onlyHolderPostalCode = computed(() => props.extra?.onlyHolderPostalCode ?? false)

  const $insuredInfoComponent = ref()

  const postalCodeRules = computed(() => {
    if (
      props.configurations.businessLine === BranchEnum.HEALTH ||
      props.configurations.businessLine === BranchEnum.FOREIGN_HEALTH
    ) {
      return [isNotFromNavarra]
    }
    return []
  })

  function triggerSubmit() {
    const result = $insuredInfoComponent.value!.submit()
    if (!result) return
    const { insureds, policyHolderPostal } = result

    const page = props.nextForm[0]

    const answers = { insureds, policyHolderPostal }
    return { page, answers }
  }

  onBeforeMount(async () => {
    if (props.configurations.businessLine === BranchEnum.HEALTH && !props.configurations.isPymes) {
      await props.store.loadMaxAgeByBusinessLine({})
    }
  })
</script>
